export default __webpack_public_path__ + "static/media/benefit_10@3x.9f61cbf8.png";